import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddMessage } from 'src/app/models/message';
import { AlertifyService } from 'src/app/services/alertify.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommunicationService } from 'src/app/services/communication.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  @Input() src: any;
  @Input() appearanceId: any;
  @ViewChild('chatHistory') private chatHistory: ElementRef;

  public Message: string;
  public currentUser: Number;
  public Messages: any;

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private alertify: AlertifyService,
    private communicationService: CommunicationService,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    // Scroll to bottom when the view is initially loaded
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    // Scroll to bottom after any view changes (e.g., new messages)
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.chatHistory.nativeElement.scrollTop = this.chatHistory.nativeElement.scrollHeight;
    } catch (err) {
      console.error('Error while scrolling to bottom', err);
    }
  }
  ngOnInit() {
    this.currentUser = this.authService.currentUserValue.id || 0;
    this.GetAllMessageByAppearanceId();
  }

  AddMessage() {
    this.spinner.show();
    const addMessage: AddMessage = {
      parentMessageId: 0,
      appearanceId: this.appearanceId,
      fromId: this.authService.currentUserValue.id || 0,
      toId: this.src,
      message:  this.Message,
      fromIdRole: this.authService.currentUserValue.profileType || ''
    }

    this.communicationService.addMessage(addMessage).subscribe(msg => {
      if (msg.isSuccess) {
        this.GetAllMessageByAppearanceId();
        this.alertify.success(msg.message);
        this.Message = '';
        this.spinner.hide();
        setTimeout(() => this.scrollToBottom(), 100);
      }
    });
  }
  reply(msg: any) {
    this.Message = msg.fromFirstName + ':';
    this.src = msg.fromId;
  }
  GetAllMessageByAppearanceId() {
    //this.authService.currentUserValue.id
    this.communicationService.getMessageByAppearanceId(this.appearanceId, this.src).subscribe(msg => {
      this.Messages = msg//.reverse();
    });
  }
}
